export default __webpack_public_path__ + "static/media/emmaMk.feefaacc.jpg";